import React, { Component } from 'react';
import { PhoneIcon, MailIcon, AlertTriangleIcon, MapPinIcon } from 'lucide-react';
import Header from '../components/Header';
const Contact = () => {
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-231">
      <Header title="Contact & Noodgevallen" showBackButton data-id="element-232" />
      <div className="p-4" data-id="element-233">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4" data-id="element-234">
          <div className="flex items-start" data-id="element-235">
            <AlertTriangleIcon size={24} className="text-red-500 mr-3 mt-0.5" data-id="element-236" />
            <div data-id="element-237">
              <h2 className="text-lg font-bold text-red-700 mb-1" data-id="element-238">
                Noodgevallen
              </h2>
              <p className="text-sm text-red-700 mb-3" data-id="element-239">
                Bij noodgevallen kun je direct contact opnemen:
              </p>
              <div className="space-y-2" data-id="element-240">
                <button className="w-full bg-red-600 text-white py-2 rounded-lg flex items-center justify-center" data-id="element-241">
                  <PhoneIcon size={18} className="mr-2" data-id="element-242" />
                  Bel noodnummer: 112
                </button>
                <button className="w-full bg-red-100 text-red-700 py-2 rounded-lg flex items-center justify-center" data-id="element-243">
                  <PhoneIcon size={18} className="mr-2" data-id="element-244" />
                  Bel receptie: +32 (0)80 123 456
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-4 mb-4" data-id="element-245">
          <h2 className="text-lg font-bold mb-3" data-id="element-246">Contact Camping Olympia</h2>
          <div className="space-y-3" data-id="element-247">
            <ContactItem icon={<PhoneIcon size={20} data-id="element-249" />} title="Telefoon" content="+32 (0)80 123 456" action="call" data-id="element-248" />
            <ContactItem icon={<MailIcon size={20} data-id="element-251" />} title="E-mail" content="info@olympia-campings.com" action="mail" data-id="element-250" />
            <ContactItem icon={<MapPinIcon size={20} data-id="element-253" />} title="Adres" content="Rue de l'Amblève 12, 4970 Stavelot, België" action="map" data-id="element-252" />
          </div>
          <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-254">
            <p className="text-sm text-gray-600" data-id="element-255">
              <strong data-id="element-256">Afstand vanaf Utrecht:</strong> 238 km
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-257">
          <h2 className="text-lg font-bold mb-3" data-id="element-258">Openingstijden Receptie</h2>
          <div className="space-y-2" data-id="element-259">
            <div className="flex justify-between" data-id="element-260">
              <span className="text-sm" data-id="element-261">Maandag - Vrijdag</span>
              <span className="text-sm font-medium" data-id="element-262">08:00 - 20:00</span>
            </div>
            <div className="flex justify-between" data-id="element-263">
              <span className="text-sm" data-id="element-264">Zaterdag</span>
              <span className="text-sm font-medium" data-id="element-265">08:00 - 22:00</span>
            </div>
            <div className="flex justify-between" data-id="element-266">
              <span className="text-sm" data-id="element-267">Zondag</span>
              <span className="text-sm font-medium" data-id="element-268">09:00 - 19:00</span>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-269">
            <h3 className="font-medium mb-2" data-id="element-270">Aankomst & Vertrek</h3>
            <div className="space-y-2" data-id="element-271">
              <div className="flex justify-between" data-id="element-272">
                <span className="text-sm" data-id="element-273">Aankomst vanaf</span>
                <span className="text-sm font-medium" data-id="element-274">14:00</span>
              </div>
              <div className="flex justify-between" data-id="element-275">
                <span className="text-sm" data-id="element-276">Vertrek voor</span>
                <span className="text-sm font-medium" data-id="element-277">11:00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const ContactItem = ({
  icon,
  title,
  content,
  action
}) => {
  let actionProps = {};
  if (action === 'call') {
    actionProps.onClick = () => window.location.href = `tel:${content.replace(/\s/g, '')}`;
  } else if (action === 'mail') {
    actionProps.onClick = () => window.location.href = `mailto:${content}`;
  } else if (action === 'map') {
    actionProps.onClick = () => window.location.href = `https://maps.google.com/?q=${encodeURIComponent(content)}`;
  }
  return <button className="flex items-center w-full p-2 hover:bg-gray-50 rounded-lg" {...actionProps} data-id="element-278">
      <div className="text-[#f9b30f] mr-3" data-id="element-279">{icon}</div>
      <div className="text-left" data-id="element-280">
        <p className="font-medium" data-id="element-281">{title}</p>
        <p className="text-sm text-gray-600" data-id="element-282">{content}</p>
      </div>
    </button>;
};
export default Contact;